type AuthResponse = Record<string, unknown>;

const asRecord = (value: unknown): AuthResponse =>
  value !== null && typeof value === 'object' && !Array.isArray(value)
    ? (value as AuthResponse)
    : {};

export const getRefreshToken = () => localStorage.getItem('refreshToken');

export const organizationIdFromAuth = (
  response: AuthResponse,
  fallbackOrganizationId?: string
) => {
  if (typeof response.organizationId === 'string') return response.organizationId;

  const organization = asRecord(response.organization);
  if (typeof organization.id === 'string') return organization.id;

  const user = asRecord(response.user);
  const memberships = Array.isArray(user.userOrganizations)
    ? user.userOrganizations
    : [];
  const firstMembership = asRecord(memberships[0]);
  if (typeof firstMembership.organizationId === 'string') {
    return firstMembership.organizationId;
  }

  return fallbackOrganizationId;
};

/** Store every rotated credential returned by Ticketin in one place. */
export const storeAuthSession = (
  response: AuthResponse,
  fallbackOrganizationId?: string
) => {
  if (typeof response.token === 'string' && response.token) {
    localStorage.setItem('token', response.token);
  }
  if (typeof response.refreshToken === 'string' && response.refreshToken) {
    localStorage.setItem('refreshToken', response.refreshToken);
  }
  if (response.user && typeof response.user === 'object') {
    localStorage.setItem('user', JSON.stringify(response.user));
  }
  if (Array.isArray(response.roles)) {
    localStorage.setItem('roles', JSON.stringify(response.roles));
  }

  const organizationId = organizationIdFromAuth(response, fallbackOrganizationId);
  if (organizationId) localStorage.setItem('orgId', organizationId);
  return organizationId;
};

export const clearAuthSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
  localStorage.removeItem('orgId');
  localStorage.removeItem('roles');
};
